var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tweetAddress
    ? _c(
        "div",
        { key: _vm.tweetAddress, staticClass: "container" },
        [
          _c("h1", [_vm._v("Results")]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.tweet
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6 mb-4" },
                    [
                      _vm.tweet
                        ? _c("tweet-veracity-display", {
                            attrs: { tweet: _vm.tweet, user: _vm.user }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tweet-replies")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-6 mb-4" },
                    [
                      _c("tweet-user-profile", {
                        attrs: { "tweet-user": _vm.tweetUser }
                      }),
                      _vm._v(" "),
                      _c("tweet-metadata", {
                        attrs: {
                          "external-urls": _vm.tweet.external_urls,
                          "media-entities": _vm.tweet.media_entities,
                          "replies-external-urls": _vm.repliesExternalUrls,
                          "replies-media-entities": _vm.repliesMediaEntities
                        }
                      })
                    ],
                    1
                  )
                ])
              : _c("div", [
                  _c("p", { staticClass: "font-weight-bold" }, [
                    _c("span", {
                      staticClass: "spinner-grow spinner-grow-sm mr-2",
                      attrs: { role: "status", "aria-hidden": "true" }
                    }),
                    _vm._v(
                      "\n                Searching for tweet...\n            "
                    )
                  ])
                ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }